import { Injectable } from '@angular/core';
import { Api } from '../../contracts/classes/api.class';
import { Observable } from 'rxjs';
import { IResponse } from '../../contracts/models/response.model';
import { CreateTypeEmailDTO, TypeEmail, updateOrderTypeEmailDTO, UpdateTypeEmailDTO } from '../../contracts/models/type-email.model';

@Injectable({
  providedIn: "root"
})
export class TypeEmailService extends Api{

  getAll(): Observable<IResponse<TypeEmail[]>> {
    return this.http.get<IResponse<TypeEmail[]>>(`${this.url}/tipoCorreo`);
  }

  create(createTypeEmailDTO: CreateTypeEmailDTO): Observable<IResponse<TypeEmail>> {
    return this.http.post<IResponse<TypeEmail>>(`${this.url}/tipoCorreo`, createTypeEmailDTO);
  }

  update(updateTypeEmailDTO: UpdateTypeEmailDTO): Observable<IResponse<TypeEmail>> {
    return this.http.put<IResponse<TypeEmail>>(`${this.url}/tipoCorreo/${updateTypeEmailDTO.id}`, updateTypeEmailDTO);
  }

  delete(id: number): Observable<IResponse<TypeEmail>> {
    return this.http.delete<IResponse<TypeEmail>>(`${this.url}/tipoCorreo/${id}`);
  }

  updateOrder(updateOrderTypeEmailDTO: updateOrderTypeEmailDTO[]): Observable<IResponse<TypeEmail[]>> {
    return this.http.put<IResponse<TypeEmail[]>>(`${this.url}/tipoCorreo/data/updateOrder`, {
      tipoCorreos: updateOrderTypeEmailDTO
    });
  }
}
